import { Radio, Row, Table } from 'antd'
import { useState } from 'react'

import Box from '~/core/Box'
import TruncatedText from '~/core/TruncatedText'
import { UNITS_IN, UNITS_MM } from '~/lib/getDimensionsDisplayWithUnits'
import {
    convertInchesToMilimeters,
    convertMilimetersToInches,
} from '../PartsDropzone/logic'
import { getenv } from '~/settings'

type UnitsSectionPropsType = {
    meshFiles: File[]
    onUnitsChange: (unit: string) => void
    dimensions: string
    units: string
}

const FILE_NAME_MAX_LENGTH = 37

const UnitsSection = (props: UnitsSectionPropsType) => {
    const { meshFiles, onUnitsChange, dimensions, units } = props
    const [selectedUnit, setSelectedUnit] = useState(units ? units : 'mm')

    const COLUMNS = [
        {
            title: 'Name',
            key: 'preview',
            width: '50%',
            render(record: { name: string }) {
                return (
                    <TruncatedText maxLength={FILE_NAME_MAX_LENGTH}>
                        {record.name}
                    </TruncatedText>
                )
            },
        },
        {
            title: 'Dimensions',
            key: 'dimensions',
            render(record: { dimensions: string }) {
                return (
                    <Row>
                        {selectedUnit === 'mm' ? (
                            <div>
                                <div>{`${record.dimensions} mm`}</div>
                                <div>
                                    {convertMilimetersToInches(
                                        record.dimensions,
                                    ).join(' x ')}{' '}
                                    inches
                                </div>
                            </div>
                        ) : (
                            <div>
                                <div>
                                    {`${convertInchesToMilimeters(
                                        record.dimensions,
                                    ).join(' x ')}  mm`}
                                </div>
                                <div>{`${record.dimensions} inches`}</div>
                            </div>
                        )}
                    </Row>
                )
            },
        },
    ]

    const onUnitsChangeHandler = (e: any) => {
        onUnitsChange(e.target.value)
        setSelectedUnit(e.target.value)
    }

    const updatedFileData = meshFiles.map((item, i) =>
        Object.assign({}, { ...item }, dimensions[i]),
    )

    return (
        <>
            <Box marginBottom="16px" display="block">
                In order to upload your parts with the correct dimensions, we
                need to know which units your software exported them in.
            </Box>
            <Box marginBottom="16px" display="block">
                <Box>
                    {/* Parts modeled in{' '} */}
                    Use the options below to determine the correct dimensions
                    for your parts.
                </Box>
                <Radio.Group
                    onChange={onUnitsChangeHandler}
                    defaultValue={selectedUnit}
                    size="small"
                    style={{ marginTop: '15px' }}
                >
                    <Radio value={UNITS_MM}>Millimeters ({UNITS_MM})</Radio>
                    <Radio value={UNITS_IN}>Inches</Radio>
                </Radio.Group>
            </Box>
            <Box width="100%">
                <Table
                    dataSource={updatedFileData}
                    rowKey="uid"
                    size="small"
                    style={{ width: '100%' }}
                    pagination={false}
                    columns={COLUMNS}
                />
            </Box>
            <Box marginTop="20px">
                <a
                    href={`${
                        getenv('REGIONAL_CONFIGS')?.urls
                            ?.what_file_formats_does_fictiv_support
                    }`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Learn more about uploading mesh files
                </a>
            </Box>
        </>
    )
}

export default UnitsSection
